<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>									
				<v-flex lg6>
					<label class="blackLabel">* Minimum Blinds:</label>			
                  <v-text-field label="Minimum Blinds" type="number" v-model="minBlinds" required :rules="minRules" single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Maximum Blinds:</label>
					<v-text-field label="Maximum Blinds" type="number" v-model="maxBlinds" required :rules="maxRules" single-line solo></v-text-field>
				</v-flex>				
				<v-flex lg6>
					<label class="blackLabel">* Total Price:</label>
                    <v-text-field label="Total Price" type="number" v-model="total" required :rules="totalRules" single-line solo></v-text-field>
				</v-flex>			
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddTier()">Save</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
				isAddValid: false,
                minBlinds: '',
                maxBlinds: '',				
                total: '',
				minRules: [
					v => !!v || 'Minimum blinds is required',				
				],
				maxRules: [
					v => !!v || 'Maximum blinds is required',				
				],
				totalRules: [
					v => !!v || 'Price is required',				
                ]                
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncAddTier() {				
				this.$store.dispatch({
                  type: 'fncAddTier',					
				  minBlinds: this.minBlinds,
				  maxBlinds: this.maxBlinds,
				  total: this.total
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>